import * as Yup from 'yup'

import { EMPTY_OBJECT } from '../../../../../constants/common'
import { formValidationSchemaNoChanged } from '../../../../Form'
import {
  getListingBuildingShortAddress,
  LISTING_FORM_FIELD_NAME_BUILDING,
  LISTING_FORM_FIELD_NAME_FLAT,
  toListingFlatSelectItems,
} from '../../../../RentalPortalListing'
import { RentalPortalBlockDisabledEditButton } from '../../../RentalPortalBlockDisabledEditButton'

function isListingAddressFlatEqual({ initialValues, values }) {
  return (
    initialValues[LISTING_FORM_FIELD_NAME_FLAT]?.value ===
    values[LISTING_FORM_FIELD_NAME_FLAT]?.value
  )
}

export function isNeedToShowListingAddressItemIcons() {
  return false
}

export function getListingAddressFlatText({ flat, t }) {
  return `${t('Common.FlatSelectListItemNumberPrefixKey')} ${flat.number}`
}

export function getListingAddressInitialValues({ listing, t }) {
  return {
    [LISTING_FORM_FIELD_NAME_BUILDING]: listing?.flat?.building
      ? {
          label: getListingBuildingShortAddress(listing.flat.building),
          value: listing.flat.building.id,
        }
      : null,
    [LISTING_FORM_FIELD_NAME_FLAT]: listing?.flat
      ? toListingFlatSelectItems({ items: [listing.flat], t })[0]
      : null,
  }
}

export function getListingAddressPatchPayload(values) {
  return { flat_id: values[LISTING_FORM_FIELD_NAME_FLAT].value }
}

export function getListingAddressValidationSchema({ initialValues }) {
  return Yup.object({
    [LISTING_FORM_FIELD_NAME_FLAT]: Yup.object().nullable().required(true),
  }).concat(
    formValidationSchemaNoChanged({
      initialValues,
      isEqual: isListingAddressFlatEqual,
    })
  )
}

export function getListingAddressActionsProps(listing) {
  if (!listing?.permissions?.can_edit) {
    return { EditButton: RentalPortalBlockDisabledEditButton }
  }

  return listing.unit_locked
    ? {
        EditButton: RentalPortalBlockDisabledEditButton,
        editButtonProps: {
          tooltipKey: 'RentalPortal.ListingAddressDraftOnlyTooltipKey',
        },
      }
    : EMPTY_OBJECT
}
